const PREFIX = "hb";
export function setComponent(name, constructor, options) {
    window.customElements.define(`${PREFIX}-${name}`, constructor, options);
}
